module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/notosanskr/notokr-light.woff2
// module id = 7h2I
// module chunks = 0